import React from "react"
import SEO from "../components/seo"
import Video from "../components/Video"
import VideoMobile from "../components/VideoMobile"

export default function NikePage(props) {
  return (
    <div id="nike-play-with-fire">
      <VideoMobile
        title="Nike, Play with fire• Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234409984?&title=0&muted=0"
        allowsInlineMediaPlayback="true"
      />
      <Video
        title="Nike, Play with fire• Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234409984?background=1&autoplay=1&loop=1&byline=0&title=0&muted=0"
      />
      <SEO title={props.title} />
    </div>
  )
}
